export default {"src":"/_next/static/media/0x765277eebeca2e31912c9946eae1021199b39c61.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};